import { ErrorTypes } from '@/types/error';

export class InvalidScanCodeError extends Error {
  constructor(message = '') {
    super(message);
    this.name = ErrorTypes.INVALID_SCAN_CODE;
  }
}
